import request from '@/axios'

/**
 * @Description: 获取应用软件推荐
 * imgHas
 */
export function getRecommendApp(data){
  return request({
    method: 'post',
    url: '/api/Applys/selectApplysByRecommend',
    params: data
  })
}

/**
 * @Description: 获取逻辑组件推荐
 * imgHas
 */
export function getRecommendLogicApp(data){
  return request({
    method: 'post',
    url: '/api/LogicalComponent/selectLogicalComponentByRecommend',
    params: data
  })
}

/**
 * @Description: 获取协议组件推荐
 * imgHas
 */
export function getRecommendProtocolApp(data){
  return request({
    method: 'post',
    url: '/api/ProtocolComponent/selectProtocolComponentByRecommend',
    params: data
  })
}

/**
 * @Description: 获取排行榜top10的应用软件展示数据
 */
export function getTop10(data){
  return request({
    method: 'post',
    url: '/api/Applys/selectApplysListTopTen',
    params: data
  })
}

/**
 * @Description: 获取排行榜top3的逻辑组件展示数据
 */
export function getLogicTop3(data){
  return request({
    method: 'post',
    url: '/api/LogicalComponent/selectLogicalComponentListTopThree',
    params: data
  })
}

/**
 * @Description: 获取排行榜top3的协议组件展示数据
 */
export function getProtocolTop3(data){
  return request({
    method: 'post',
    url: '/api/ProtocolComponent/selectProtocolComponentListTopThree',
    params: data
  })
}

/**
 * @Description: 下载应用软件
 */
export function downloadApp(appId){
  return request({
    method: 'get',
    url: '/api/Applys/getAppUrl',
    params: {
      appId
    }
  })
}

/**
 * @Description: 分页获取分类应用软件
 * imgHas
 */
export function sortAppPageData(applyName, applytypeId, curPage, pageSize){
  return request({
    method: 'post',
    url: '/api/Applys/selectApplysListByApplystypeId',
    params: {
      applyName,
      applytypeId,
      curPage,
      pageSize
    }
  })
}

/**
 * @Description: 分页获取分类逻辑组件
 * imgHas
 */
export function sortLogicAppPageData(data){
  return request({
    method: 'post',
    url: '/api/LogicalComponent/selectLogicalComponentList',
    data: data
  })
}

/**
 * @Description: 分页获取协议逻辑组件
 * imgHas
 */
export function sortProtocolAppPageData(data){
  return request({
    method: 'post',
    url: '/api/ProtocolComponent/selectProtocolComponentList',
    data: data
  })
}
